import src from "IMAGE";
export default { src, width: 315, height: 193, blurWidth: 0, blurHeight: 0};
